import { ReportComponent } from './../report-component';
import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { HistApi } from 'src/app/services/api-service/hist/hist-api';
import { EasyNotificationService } from 'src/app/services/easy-notification.service';
//import { LocalPrintService } from 'src/app/services/local-print.service';
import { ReportComponentService } from '../report-component.service';
import { ClinicDataService } from 'src/app/services/data-service/clinic-data-service';
import { UserCache } from 'src/app/services/user-cache';

export class ArrearReceiptViewModel {
  PatientBirthDay: Date;
  PatientName: string;
  PatientCId: string;
  OutpatientDay: Date;
  OutpatientTime: string;
  ICTypeName: string;
  MissingCardDeposit: number;
  ClinicName: string;
  ClinicAddress: string;
  ClinicPhone: string;
}


@Component({
  selector: 'app-arrear-receipt',
  templateUrl: './arrear-receipt.component.html',
  styleUrls: ['./arrear-receipt.component.css']
})

export class ArrearReceiptComponent implements ReportComponent, OnInit {
  @ViewChild('reportContainer', { static: false })
  reportContainer: ElementRef<HTMLDivElement>;

  @Input()
  regId: number;

  arrearReceiptViewModel: ArrearReceiptViewModel = null;

  initHasException: boolean = false;
  /** 列印字體 */
  fontType: string = '細明體';
  cidMask = '1234567890'
  bitrhMask = 'YYY年MM月DD日'
  fontSize: string = 'x-large';

  constructor(private histApi: HistApi,
    //private localPrintService: LocalPrintService,
     private clinicDataService: ClinicDataService,
    private notification: EasyNotificationService,
    
    private changeDetectorRef: ChangeDetectorRef,
    private reportComponentService: ReportComponentService
  ) { }

  ngOnInit(): void {

    var cln = UserCache.getLoginUser().ClinicName;
    if (cln && cln.length > 7) {
      this.fontSize = '16px';
    }
    this.arrearReceiptViewModel = {
      PatientBirthDay: null,
      PatientName: "",
      PatientCId: "",
      OutpatientDay: null,
      OutpatientTime: "",
      ICTypeName: "",
      MissingCardDeposit: 0,
      ClinicName: "",
      ClinicAddress: "",
      ClinicPhone: ""
    }

    //this.getHistArrearReceipt(this.regId);
  }

  async getHistArrearReceipt(regid) {
    var cln = UserCache.getLoginUser().ClinicName;
    if (cln && cln.length > 7) {
      this.fontSize = '16px';
    }
    if (regid) {
      await this.histApi.GetHistArrearReceipt(regid)
        .then(result => {
          this.arrearReceiptViewModel = result;
          if (this.arrearReceiptViewModel) {
            this.fontSize = (this.arrearReceiptViewModel.ClinicName.length <= 7 ? 'x-large' : '16px');
          }
        })
        .catch(error => {
          this.notification.showError(error.message);
          this.initHasException = true;
        });
      this.arrearReceiptViewModel.MissingCardDeposit = Math.floor(this.arrearReceiptViewModel.MissingCardDeposit);
      var param = await this.clinicDataService.getParam("PRN001");
      this.fontType = (param.FontTypeForPrint == 0 ? '細明體' : (param.FontTypeForPrint == 1 ? '標楷體' : (param.FontTypeForPrint == 2 ? '微軟正黑體' : '細明體')));
      this.cidMask = param.IDHidePRN ?? this.cidMask;
      this.bitrhMask = param.BirthdayHidePRN ?? this.bitrhMask;
      this.changeDetectorRef.detectChanges();
    }

  }

  // async onPrint(): Promise<boolean> {
  //   await this.getHistArrearReceipt(this.regId);

  //   if (this.initHasException) {
  //     this.initHasException = false;
  //     return false;
  //   }

  //   if (this.arrearReceiptViewModel) {
  //     const reportName = '欠卡單';

  //     let printContents = this.getHtml();
  //     var ret = await this.localPrintService.printHtml(810, reportName, printContents);  // 'Consultation Volume Statistic'
  //     if (ret.Successed) {
  //       this.notification.showSuccess(reportName + '已送出列印!', true);
  //       return true;
  //     } else {
  //       this.notification.showError(reportName + '送出列印失敗!');
  //       return false;

  //     }
  //   } else {
  //     this.notification.showInfo('查無資料可供列印!');
  //     return false;
  //   }
  // }

  getHtml(): string {
    let cssText = this.reportComponentService.getAllCss(this.reportContainer.nativeElement);

    let style = `
      <style>
        ${cssText}

        @page {
          size: '21.5cm 9cm;';
          margin: 0cm;
          padding: 0cm;
        }
      </style>
    `;

    var html = this.reportContainer.nativeElement.innerHTML;

    let fullHtml = `
    <html>
      <head>${style}</head>
      <body style="margin: 0cm;padding:0cm">${html}</body>
    </html>`;

    return fullHtml;
  }
}
